/* global console, document, Office */
import Papa from 'papaparse';
import LogHelper from "./logHelper";
import { displayData } from "./excelUtils";

const logHelper = new LogHelper();

export function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
}

export function parseCSV(csvData) {
  return new Promise((resolve, reject) => {
    Papa.parse(csvData, {
      header: false,
      skipEmptyLines: false,
      complete: async (results) => {
        if (results.data.length === 0) {
          console.log("⚠️ CSV is empty!");
          await logHelper.writeLog(logHelper.LogTypes.Warn, "⚠️ CSV is empty!");
          reject([]);
        } else {
          // Clean the CSV data to remove stair-step format
          const cleanedData = await cleanCSVData(results.data);
          resolve(cleanedData);
        }
      },
      error: (error) => reject(error),
    });
  });
}
async function cleanCSVData(rawData) {
  try {
    // Determine the maximum row length to ensure consistent output
    const maxColumns = Math.max(...rawData.map(row => row.length));

    // Initialize output data
    const outputData = [];

    // Process each row
    for (let row of rawData) {
      // Normalize row to maxColumns, converting to strings
      const normalizedRow = Array(maxColumns).fill('');
      for (let i = 0; i < Math.min(row.length, maxColumns); i++) {
        normalizedRow[i] = row[i] != null ? String(row[i]).trim() : '';
      }

      // Skip completely empty rows
      if (normalizedRow.every(cell => cell === '')) {
        outputData.push(normalizedRow);
        continue;
      }

      // Find the index of the first non-empty cell
      let firstNonEmptyIndex = -1;
      for (let i = 0; i < normalizedRow.length; i++) {
        if (normalizedRow[i] !== '') {
          firstNonEmptyIndex = i;
          break;
        }
      }

      // If no non-empty cells, keep the row as-is
      if (firstNonEmptyIndex === -1) {
        outputData.push(normalizedRow);
        continue;
      }

      // If first non-empty cell is already in column A, keep the row as-is
      if (firstNonEmptyIndex === 0) {
        outputData.push(normalizedRow);
        continue;
      }

      // Shift all values left so first non-empty cell is in column A
      const newRow = Array(maxColumns).fill('');
      let newIndex = 0;
      for (let i = firstNonEmptyIndex; i < normalizedRow.length; i++) {
        newRow[newIndex] = normalizedRow[i];
        newIndex++;
      }
      outputData.push(newRow);
    }

    // Log success
    await logHelper.writeLog(logHelper.LogTypes.Msg, "CSV data cleaned successfully.");
    return outputData;
  } catch (error) {
    await logHelper.writeLog(logHelper.LogTypes.Error, `Error cleaning CSV data: ${error}`);
    throw error;
  }
}

export async function readCSVFiles() {
  await logHelper.writeLog(logHelper.LogTypes.Msg, "Process started to import and export data.");
  const files = document.getElementById("fileInput").files;
  if (files.length === 0) {
    console.log("Please select at least one CSV file.");
    await logHelper.writeLog(logHelper.LogTypes.Warn, "Please select at least one CSV file.");
    return;
  }

  await logHelper.writeLog(logHelper.LogTypes.Msg, `${files.length} number of files to import and export data.`);
  for (let file of files) {
    try {
      console.log(`Started process for ${file.name} file.`);
      await logHelper.writeLog(logHelper.LogTypes.Msg, `Started process for '${file.name}' file.`);
      const csvData = await readFileAsText(file);
      const parsedData = await parseCSV(csvData);
      await displayData(file.name, parsedData);
      console.log(`Process completed for ${file.name} file.`);
      await logHelper.writeLog(logHelper.LogTypes.Msg, `Process completed for '${file.name}' file.`);
    } catch (error) {
      console.log(`Error while processing for ${file.name}. Error details are, `, error);
      await logHelper.writeLog(logHelper.LogTypes.Error, `Error while processing for '${file.name}'. Error details are, ${error}`);
    }
  }
  disabledProcessButton();
  await logHelper.writeLog(logHelper.LogTypes.Msg, "Process completed to import and export data. Please check your download folder exported files.");
}

export function handleFiles(event) {
  const files = event.target.files || event.dataTransfer.files;
  const fileInput = document.getElementById("fileInput");
  const fileList = document.getElementById('fileList');

  // Clear the UI
  fileList.innerHTML = '';

  // For drag-and-drop only, update fileInput.files
  if (event.dataTransfer) {
    const dataTransfer = new DataTransfer();
    Array.from(files).forEach(file => dataTransfer.items.add(file));
    fileInput.files = dataTransfer.files;
  }

  // Update the UI with the new files
  Array.from(files).forEach(file => {
    let listItem = document.createElement('li');
    listItem.innerHTML = `<div id="${file.name}"><span class="filename">${file.name}</span>
                          <div class="validationSection hide"></div>
                        </div><button class="remove-btn" onclick="removeFile(this)"><i class="ms-Icon ms-Icon--Delete" aria-hidden="true"></i></button>`;
    fileList.appendChild(listItem);
  });
  toggleProcessButton();
}

window.removeFile = function (button) {
  const fileName = button.previousSibling.textContent.trim();
  let listItem = button.parentElement;
  listItem.remove();
  updateFileInput(fileName);
  toggleProcessButton();
};

function updateFileInput(filename) {
  const fileInput = document.getElementById("fileInput");
  let files = [...fileInput.files];
  files = files.filter(file => file.name !== filename);
  const dataTransfer = new DataTransfer();
  files.forEach(file => dataTransfer.items.add(file));
  fileInput.files = dataTransfer.files;
}

function toggleProcessButton() {
  const processBtn = document.getElementById('processBtn');
  const fileList = document.getElementById('fileList');
  processBtn.disabled = fileList.children.length === 0;
}

function disabledProcessButton() {
  const processBtn = document.getElementById('processBtn');
  processBtn.disabled = true;
}